import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import api from '../../services/api';
import './AnnouncementTicker.css';

interface AnnouncementData {
  active: boolean;
  text?: string;
  colorScheme?: string;
  speed?: 'slow' | 'medium' | 'fast';
}

function AnnouncementTicker() {
  const [announcement, setAnnouncement] = useState<AnnouncementData | null>(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    loadAnnouncement();
    const interval = setInterval(loadAnnouncement, 60000);
    return () => clearInterval(interval);
  }, []);

  const loadAnnouncement = async () => {
    try {
      const response = await api.get('/api/settings/public/announcement');
      setAnnouncement(response.data);
    } catch {
      setAnnouncement(null);
    }
  };

  if (!announcement?.active || !announcement.text || dismissed) {
    return null;
  }

  const colorClass = `ticker-${announcement.colorScheme || 'white-black'}`;
  const speedClass = `ticker-speed-${announcement.speed || 'medium'}`;

  return (
    <div className={`announcement-ticker ${colorClass}`}>
      <div className="announcement-ticker-inner">
        <div className={`ticker-track ${speedClass}`}>
          <span className="ticker-text">{announcement.text}</span>
        </div>
        <button
          className="ticker-dismiss"
          onClick={() => setDismissed(true)}
          title="Dismiss"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
}

export default AnnouncementTicker;
